export default __webpack_public_path__ + "static/vikas_kalwani-c4a2403da5441f87f08f16caffc8df74.png";